var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
	wp = (typeof window !== "undefined" ? window['wpVars'] : typeof global !== "undefined" ? global['wpVars'] : null);

function LoadMorePosts( el ) {
	var t = this;
	t.$el = $(el);
	t.pageNumber = 1;
	// Collect data
	t.$loadMoreButton = t.$el.find('.js-load-more-toggle');
	t.$excludePost = t.$el.data('exclude-post');
	t.$list = t.$el.find('.js-load-post');
	if( t.$loadMoreButton ) {
		t.$loadMoreButton.on("click", function( e ) {
			e.preventDefault();
			t.$loadMoreButton.attr( "disabled", true );
			t.loadPosts();
		});
	}
}

LoadMorePosts.prototype.loadPosts = function() {
	var t = this;
	t.pageNumber++;
	$.ajax({
		type: "POST",
		dataType: "json",
		url: wp.ajaxUrl,
		data: {
			pageNumber: t.pageNumber,
			excludePost: t.$excludePost,
			action: 'load_post_ajax'
		},
		success: function( data ) {
			if (! data.html) {
				console.log( 'An error occurred while getting post items. Please try again or contact site administrator.' );
				return;
			}
			t.$loadMoreButton.attr( "disabled", false );
			t.$list.append( data.html ).fadeIn( 300 );
			if (! data.hasNextPage) {
				t.$loadMoreButton.hide();
			}
		},
		error : function() {
			console.log( 'An error occurred while getting post items. Please try again or contact site administrator.' );
		}
	});
	return false;
};

module.exports = LoadMorePosts;
